// extracted by mini-css-extract-plugin
export default {"btn-back-menu":"aDDuT"};